import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import authService from './authService';

const holidayApi = axios.create({
  baseURL: `${API_BASE_URL}/holidays`,
  headers: { 'Content-Type': 'application/json' },
});

holidayApi.interceptors.request.use((config) => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

holidayApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      
      if (status === 401) {
        console.warn('Session expirée ou non authentifié');
        authService.logout();
        window.location.href = '/login';
        return Promise.reject(error);
      }
      
      if (status === 403) {
        console.warn('Accès refusé - Permissions insuffisantes');
      }
      
      if (status >= 500) {
        console.error('Erreur serveur:', error.response.data);
      }
    }
    
    return Promise.reject(error);
  }
);

const holidayService = {
  getAll: (params = {}) => {
    return holidayApi.get('', { params });
  },

  getById: (id) => holidayApi.get(`/${id}`),

  getByYear: (year) => holidayApi.get(`/year/${year}`),

  checkIfHoliday: (date) => holidayApi.get(`/date/${date}`),

  create: (data) => holidayApi.post('', data),

  update: (id, data) => holidayApi.put(`/${id}`, data),

  delete: (id) => holidayApi.delete(`/${id}`),

  initializeDefault: (year) => holidayApi.post(`/initialize/${year}`),

  applyRecurring: (year) => holidayApi.post(`/apply-recurring/${year}`),
};

export default holidayService;

